import { AdditionalWordProps } from '../../types/common'
import { useAppSelector } from '../../utils/agent.store'

const EntityIdBreadcrumb: React.FC<AdditionalWordProps> = ({
  left = '',
  right = '',
}: AdditionalWordProps) => {
  const name_of_entity = useAppSelector((state) => state.entity.entityName)
  return name_of_entity ? left + name_of_entity + right : null
}

export default EntityIdBreadcrumb
